import { DomSanitizer } from '@angular/platform-browser';
import { ApiResponse } from './../models/ApiResponse';
import { BookingDeceasedProfiles } from './../models/BookingDeceasedProfiles';
import { DeceasedProfile } from './../models/DeceasedProfile';
import { DeceasedDataService } from './../service/data/deceased-data.service';
import { Alert } from './../models/Alert';
import { Account } from './../models/account';
import { BookingDataService } from './../service/data/booking-data.service';
import { BasicAuthenticationService } from './../auth/basic-authentication.service';
import { AccountDataService } from './../service/data/account-data.service';
import { SystemDataService } from './../service/data/system-data.service';
import * as moment from 'moment';
import {
  IN_OPERATION_MODE,
  OBS_IS_UNDER_MAINTENANCE,
  IN_MAINTENANCE_MODE,
  ACTIVE,
  BANNED,
  VIP_VISIT_DURATION,
  NORMAL_VISIT_DURATION
} from './../app.constant';
import { SystemConfig } from './../models/SystemConfig';
import {
  Component,
  ChangeDetectionStrategy,
  ViewChild,
  TemplateRef,
  ViewEncapsulation,
  OnInit,
  ChangeDetectorRef
} from '@angular/core';
import {
  startOfDay,
  endOfDay,
  subDays,
  addDays,
  endOfMonth,
  isSameDay,
  isSameMonth,
  addHours
} from 'date-fns';
import { Subject } from 'rxjs';
import { NgbModal, ModalDismissReasons, NgbDate, NgbModalRef, NgbModalOptions } from '@ng-bootstrap/ng-bootstrap';
import {
  CalendarEvent,
  CalendarEventAction,
  CalendarEventTimesChangedEvent,
  CalendarMonthViewDay
} from 'angular-calendar';
import { Router } from '@angular/router';
import { Source } from 'webpack-sources';
import { Booking } from '../models/Booking';

const colors: any = {
  red: { primary: '#ad2121', secondary: '#FAE3E3' },
  blue: { primary: '#1e90ff', secondary: '#D1E8FF' },
  yellow: { primary: '#e3bc08', secondary: '#FDF1BA' }
};

@Component({
  selector: 'app-book-appointment',
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
  templateUrl: './book-appointment.component.html',
  styleUrls: ['./book-appointment.component.css']
})
export class BookAppointmentComponent implements OnInit {
  readonly BOOKING_APPOINTMENT_ALERT_TOP_POSITION: string =
    'BOOKING_APPOINTMENT_ALERT_TOP_POSITION';

  @ViewChild('bannedAlertContent', { static: false })
  private bannedAlertContent;


  // @ViewChild('timeSlotAndDeceasedProfileBookingPopUpModal', { static: false })
  // private timeSlotAndDeceasedProfileBookingPopUpModal;

  @ViewChild('userConfirmationModal', { static: false })
  private userConfirmationModal;

  @ViewChild('bookingConfirmationModal', { static: false })
  private bookingConfirmationModal;

  @ViewChild('timeSlotAndDeceasedProfileBookingPopUpModal', { static: true }) timeSlotAndDeceasedProfileBookingPopUp: TemplateRef<any>;
  @ViewChild('confirmation', { static: true }) confirmation: TemplateRef<any>;

  view = 'month';

  getAvailableTimeSlotErrorMsg = '';

  viewDate: Date = new Date();

  maleString = "M";
  femaleString = "F";

  modalData: {
    action: string;
    event: CalendarEvent;
  };

  refresh: Subject<any> = new Subject();

  events: CalendarEvent[] = [];

  activeDayIsOpen = false;

  dateNow = new Date();

  calendarDateStatus: BookingCalendarDateStatus = {
    availableDate: [],
    almostFullDate: [],
    peakDate: []
  };

  dayL(day) {
    console.log(day.events[0].meta.slotleft);
  }


  refreshView(): void {
    this.refresh.next();
  }


  beforeMonthViewRender({ body }: { body: CalendarMonthViewDay[] }): void {
    body.forEach(day => {

      let availableDateArray = this.calendarDateStatus.availableDate;
      let almostFullDateArray = this.calendarDateStatus.almostFullDate;
      let peakDateArray = this.calendarDateStatus.peakDate;

      let statusFound = false;

      if (!statusFound) {
        for (var counter = 0; counter < almostFullDateArray.length; counter++) {

          let almostFullDate = new Date(almostFullDateArray[counter]);
          let calendarDate = day.date;

          if (this.compareDateOnly(almostFullDate, calendarDate)) {
            day.cssClass = 'almostfull';
            statusFound = true;
            break;
          }
        }
      }
      if (!statusFound) {
        for (let counter = 0; counter < availableDateArray.length; counter++) {
          if (this.compareDateOnly(availableDateArray[counter], day.date)) {
            day.cssClass = 'available';
            statusFound = true;
            break;
          }
        }
      }



      if (!statusFound) {
        day.cssClass = 'unavailable';
      }

    });
  }

  compareDateOnly(dateA: Date, dateB: Date) {



    let dateEqual = false;
    let monthEqual = false;
    let yearEqual = false;

    let tempDateA = new Date(dateA);
    let tempDateB = new Date(dateB);

    // console.log("DateA " + tempDateA.toLocaleString());
    // console.log("tempDateB " + tempDateB.toLocaleString());

    if (tempDateA.getDate() === tempDateB.getDate()) {
      dateEqual = true;
    }

    if (tempDateA.getMonth() === tempDateB.getMonth()) {
      monthEqual = true;
    }

    if (tempDateA.getFullYear() === tempDateB.getFullYear()) {
      yearEqual = true;
    }

    // console.log("DateA " + tempDateA.getFullYear().toString() + tempDateA.getMonth().toString() + tempDateA.getDate().toString());
    // console.log("DBteB " + tempDateB.getFullYear().toString() + tempDateB.getMonth().toString() + tempDateB.getDate().toString());



    return dateEqual && monthEqual && yearEqual;
  }

  ngbDate: NgbDate;

  timeSlots: Date[];

  timeSlotsArray: Date[][];

  searchDate(date: NgbDate) {

    console.log(JSON.stringify(date));

    this.viewDate = new Date(date.year, date.month - 1, date.day);

    console.log(this.viewDate.toLocaleString());


  }

  bookingDateShownOnModal: Date = new Date();

  private checkDayAvailability(date: Date): boolean {

    let availableDateArray = this.calendarDateStatus.availableDate;
    let almostFullDateArray = this.calendarDateStatus.almostFullDate;
    let peakDateArray = this.calendarDateStatus.peakDate;

    let theDayIsAvailable = false;

    for (let counter = 0; counter < availableDateArray.length; counter++) {
      if (this.compareDateOnly(availableDateArray[counter], date)) {
        theDayIsAvailable = true;
        break;
      }
    }

    if (!theDayIsAvailable) {
      for (var counter = 0; counter < almostFullDateArray.length; counter++) {
        if (this.compareDateOnly(almostFullDateArray[counter], date)) {
          theDayIsAvailable = true;
          break;
        }
      }
    }

    return theDayIsAvailable;
  }

  async setTimeSlots(accountId: string, date: Date) {
    // update modal booking date display
    this.bookingDateShownOnModal = date;

    // reset previous time slot records
    this.timeSlotsArray = [];

    // get time slots
    let response = await this.getAvailableTimeSlot(this.loginAccount.accountId, date);

    if (response.OK != null) {

      // time slots are succcessfully loaded
      this.getAvailableTimeSlotErrorMsg=null;
      let tempTimeSlots = response.OK;

      const rowLimit = 12;

      let tempTimeSlotArray = [];

      let count = 0;

      //#region timeSlotsArray - to display time slots in columns

      for (let counter = 0; counter < tempTimeSlots.length; counter++) {

        tempTimeSlotArray.push(tempTimeSlots[counter]);

        count++;

        if (count == rowLimit) {

          this.timeSlotsArray.push(Object.assign([], tempTimeSlotArray));

          // reset temp variable for new batch
          tempTimeSlotArray = [];
          count = 0;
        }
      }

      // last count does not exceed limit
      if (tempTimeSlotArray.length > 0) {
        // push remaining time slots
        this.timeSlotsArray.push(Object.assign([], tempTimeSlotArray));
      }

      //#endregion


    }
    else {

      this.getAvailableTimeSlotErrorMsg = response.ERROR;
    }

  }

  async setVisitDuration() {

  }

  deceasedProfileOrderImages: DeceasedProfileOrderImage[] = [];

  async setDeceasedProfiles(mainAccountId: string) {

    let response = await this.getDeceaseProfilesByMainAccountId(mainAccountId);

    if (response.OK != null) {

      var deceasedProfileArray = response.OK;

      deceasedProfileArray.forEach(deceased => {

        if (deceased.idIsFoundInStock == 1) {
          this.deceasedDataService.getDeceasedProfileImageByDeceasedId(deceased.deceasedId).subscribe(

            response => {

              if (response.OK != null && response.OK != '') {

                this.deceasedProfileOrderImages.push({

                  "order": "",
                  "deceasedProfile": deceased,
                  "image": response.OK

                });
              }
              else {

                if (deceased.gender.toUpperCase() == this.maleString) {
                  this.deceasedProfileOrderImages.push({

                    "order": "",
                    "deceasedProfile": deceased,
                    "image": "./assets/images/person1.png"

                  });
                }
                else
                  if (deceased.gender.toUpperCase() == this.femaleString) {
                    this.deceasedProfileOrderImages.push({

                      "order": "",
                      "deceasedProfile": deceased,
                      "image": "./assets/images/person3.png"

                    });
                  }

              }

              //"./assets/images/person3.png"

            },
            error => {

            }

          );
        }






      });

      //this.deceasedProfiles =

    }
  }

  sessionDuration: number;

  async setSessionDuration(account: Account) {


    let response = await this.getSessionDuration(account);

    if (response.OK != null) {

      this.sessionDuration = +response.OK.value;

    }
  }

  async dayClicked({ date, events }: { date: Date; events: CalendarEvent[] }) {

    let theDayIsAvailable = this.checkDayAvailability(date);

    this.timeSlotSelected = null;

    if (theDayIsAvailable) {

      this.setTimeSlots(this.loginAccount.accountId, date);

      this.setSessionDuration(this.loginAccount);



      this.showTimeSlotAndDeceasedProfileBookingPopUp();

      // this.modal.open(this.timeSlotAndDeceasedProfileBookingPopUp, {
      //   size: 'lg',
      //   centered: true
      // });


    }
  }




  closeBookingModal() {

    this.modal.dismissAll();

  }


  openVerticallyCentered(content): void {

    this.modal.dismissAll();

    this.modal.open(content, { size: 'lg', centered: true });
  }

  private modalRef: NgbModalRef;

  loginAccount: Account;

  constructor(
    public _DomSanitizationService: DomSanitizer,
    private systemDataService: SystemDataService,
    private accountDataService: AccountDataService,
    private basicAuthenticationService: BasicAuthenticationService,
    private bookingDataService: BookingDataService,
    private changeDetectorRefs: ChangeDetectorRef,
    private router: Router,
    private modalService: NgbModal,
    private modal: NgbModal,
    private deceasedDataService: DeceasedDataService,
  ) { }

  ngOnInit() {
    this.initialise();
  }

  async initialise() {


    this.calendarDateStatus = {
      availableDate: [],
      almostFullDate: [],
      peakDate: []
    };

    //this.dateNow;.setHours(0, 0, 0);

    this.ngbDate = new NgbDate(this.dateNow.getFullYear(), this.dateNow.getMonth() + 1, this.dateNow.getDate());

    let response = await this.getMaintenanceStatus();

    var firstKey = Object.keys(response)[0];

    var systemConfig: SystemConfig;

    if (firstKey.toUpperCase() == 'OK') {
      systemConfig = response[firstKey];

      if (systemConfig.value == IN_OPERATION_MODE) {

        let accountResponse = await this.getAccount(this.basicAuthenticationService.getAuthenticatedUser());

        if (accountResponse.OK != null) {

          this.loginAccount = accountResponse.OK;

          // if (new Date(this.loginAccount.banExpiryDate).getTime() > new Date().getTime()) {
          if (this.loginAccount.status.toUpperCase() === 'BANNED') {

            console.log('Acccount is banned...');

            this.showAccountBannedAlertModal();

            setTimeout(() => this.router.navigate(['dashboard']), 4000);
          } else {

            let bookingCalenderDateStatusrResponse = await this.getBookingCalendarDateStatus(this.loginAccount.accountId);

            if (bookingCalenderDateStatusrResponse.OK != null) {

              this.calendarDateStatus = bookingCalenderDateStatusrResponse.OK;

              this.populateEvent(this.calendarDateStatus);

              this.refreshView();
            }
          }
        }
      } else if (systemConfig.value == IN_MAINTENANCE_MODE) {
        this.basicAuthenticationService.clearSession();
        this.router.navigate(['maintenance']);
      }
    } else if (firstKey.toUpperCase() == 'ERROR') {
    }


    this.setDeceasedProfiles(this.loginAccount.mainAccountId);
  }

  populateEvent(bookingCalendarDateStatus: BookingCalendarDateStatus) {


    // for (let i = 0; i < bookingCalendarDateStatus.peakDate.length; i++) {

    //   this.events.push(

    //     {
    //       id: i,
    //       start: new Date(bookingCalendarDateStatus.peakDate[i]),
    //       end: new Date(bookingCalendarDateStatus.peakDate[i]),
    //       title: 'Event ' + (i + 1).toString(),
    //       color: colors.red,
    //       //actions: this.actions,
    //       meta: {
    //         dayInfo: 'Peak'
    //       }
    //     }

    //   );
    // }

    for (let i = 0; i < bookingCalendarDateStatus.almostFullDate.length; i++) {

      this.events.push(

        {
          id: i,
          start: new Date(bookingCalendarDateStatus.almostFullDate[i]),
          end: new Date(bookingCalendarDateStatus.almostFullDate[i]),
          title: 'Event ' + (i + 1).toString(),
          color: colors.orange,
          //actions: this.actions,
          meta: {
            dayInfo: 'Almost Full'
          }
        }

      );
    }


  };

  //   events: CalendarEvent[] = [
  //     {
  //       id: 1,
  //       start: new Date("2019-11-10T16:00:00Z"),
  //       end: new Date("2019-11-11T16:00:00Z"),
  //       title: 'test 1',
  //       color: colors.red,
  //       //actions: this.actions,
  //       meta: {
  //         dayInfo: 'Peak'
  //       }
  //     },
  //     {
  //       start: new Date("2019-11-14T16:00:00Z"),
  //       end: new Date("2019-11-15T16:00:00Z"),
  //       title: 'test 2',
  //       color: colors.red,
  //       //actions: this.actions,
  //       meta: {
  //         dayInfo: 'Peak'
  //       }
  //     }
  //   ];

  // }

  showAccountBannedAlertModal() {
    this.modalService.open(this.bannedAlertContent).result.then(
      closeResult => {
        this.router.navigate(['dashboard']);
      },
      dismissReason => {
        this.router.navigate(['dashboard']);
      }
    );
  }


  showTimeSlotAndDeceasedProfileBookingPopUp() {
    this.modalService.open(this.timeSlotAndDeceasedProfileBookingPopUp, {
      size: 'lg',
      centered: true
    }).result.then(
      closeResult => {

        this.deceasedProfileOrderImages.forEach(element => {
          element.order = "";
        });

        this.selectedDeceasedProfile = [];
      },
      dismissReason => {


        this.deceasedProfileOrderImages.forEach(element => {
          element.order = "";
        });
        this.selectedDeceasedProfile = [];
      }
    );
  }

  showUserConfirmationModal() {
    this.modalService.open(this.userConfirmationModal).result.then(
      closeResult => {
        //this.selectedDeceasedProfile = [];
      },
      dismissReason => {
        //this.selectedDeceasedProfile = [];
      }
    );
  }

  readonly bookingBeingProcessedMessage = 'The booking is currrently being processed...please wait..'
  readonly bookingFailedMessage = 'Booking failed. Please try again later.'


  statusMessage: string;

  async confirmBooking() {

    this.statusMessage = this.bookingBeingProcessedMessage;

    this.bookingIsSuccessful = false;

    this.showBookingConfirmationModal();

    //let deceasedArrayId = this.selectedDeceasedProfile.map(profile => profile.deceasedId);
    Date.now
    var booking = new Booking("",
      this.loginAccount.accountId,
      this.timeSlotSelected,
      moment(this.timeSlotSelected).add(this.sessionDuration, 'm').toDate(),
      "",
      new Date(),
      new Date(),
      "",
      new Date(),
      "");

    var myArray = [];
    for (var i = 0, len = this.selectedDeceasedProfile.length; i < len; i++) {
      myArray.push(this.selectedDeceasedProfile[i].deceasedProfile);
    }

    var bookingDeceasedProfile = new BookingDeceasedProfiles(booking, myArray);

    let response = await this.createBooking(bookingDeceasedProfile);

    var firstKey = Object.keys(response)[0];

    if (firstKey.toUpperCase() == 'OK') {

      this.bookingIsSuccessful = true;


    }
    else
      if (firstKey.toUpperCase() == 'ERROR') {

        this.statusMessage = this.bookingFailedMessage;

        setTimeout(() => {

          console.log("  this.modalService.dismissAll();");

          this.modalService.dismissAll();
        }, 3000);
      }
  }

  bookingIsSuccessful = false;

  ngbModalOptions: NgbModalOptions = {
    backdrop: 'static',
    keyboard: false
  };

  showBookingConfirmationModal() {
    this.modalService.open(this.bookingConfirmationModal, this.ngbModalOptions).result.then(
      closeResult => {
        this.selectedDeceasedProfile = [];

        this.deceasedProfileOrderImages.forEach(element => {
          element.order = "";
        });

        this.modalService.dismissAll();
      },
      dismissReason => {
        this.selectedDeceasedProfile = [];

        this.deceasedProfileOrderImages.forEach(element => {
          element.order = "";
        });
        this.modalService.dismissAll();
      }
    );
  }


  //   createBooking() {

  //     // let accountId = this.firstFormGroup.get('addBookingAccountId').value;
  //     // let bookingDate = this.secondFormGroup.get('addBookingDate').value;
  //     // let bookingTime = this.thirdFormGroup.get('addBookingTime').value;
  //     // let deceasedIds = this.fourthFormGroup.get('addBookingDeceased').value;

  //     this.cmsService.createBooking(accountId, bookingDate, bookingTime, deceasedIds).subscribe(

  //         response => {

  //             this.showAlertMessage(response, this.BOOKING_LISTING_ALERT_POSITION, 5000);
  //         },
  //         error => {

  //         }

  //     )
  //     this.resetAddBookingFormGroups();

  // }



  public createBooking(bookingDeceasedProfiles: BookingDeceasedProfiles): Promise<any> {
    return this.bookingDataService.createBooking(bookingDeceasedProfiles)
      .toPromise();
  }

  public getAvailableTimeSlot(accountId: string, bookingDate: Date): Promise<ApiResponse<Date[]>> {
    return this.bookingDataService.getAvailableTimeSlot(accountId, bookingDate)
      .toPromise<ApiResponse<Date[]>>();
  }

  public getMaintenanceStatus(): Promise<any> {
    return this.systemDataService
      .getSystemConfig(OBS_IS_UNDER_MAINTENANCE)
      .toPromise();
  }

  public getSessionDuration(account: Account): Promise<ApiResponse<SystemConfig>> {

    let config = "";

    if (account.accountType.toUpperCase() != "VIP") {
      config = NORMAL_VISIT_DURATION;
    }
    else {
      config = VIP_VISIT_DURATION;
    }

    return this.systemDataService
      .getSystemConfig(config)
      .toPromise<ApiResponse<SystemConfig>>();
  }

  public getDeceaseProfilesByMainAccountId(mainAccountId: string): Promise<ApiResponse<DeceasedProfile[]>> {
    return this.deceasedDataService
      .getDeceaseProfileByMainAccountId(mainAccountId)
      .toPromise();
  }

  public getAccount(accountId: string): Promise<ApiResponse<Account>> {
    return this.accountDataService.getAccount(accountId).toPromise<ApiResponse<Account>>();
  }

  public getBookingCalendarDateStatus(accountId: string): Promise<ApiResponse<BookingCalendarDateStatus>> {
    return this.bookingDataService.getBookingCalendarDateStatus(accountId).toPromise<ApiResponse<BookingCalendarDateStatus>>();
  }


  selectedDeceasedProfile: DeceasedProfileOrderImage[] = [];

  findSelectedProfile(deceasedProfileOrderImage: DeceasedProfileOrderImage) {

    for (let i = 0; i < this.selectedDeceasedProfile.length; i++) {

      if (this.selectedDeceasedProfile[i].deceasedProfile.deceasedId === deceasedProfileOrderImage.deceasedProfile.deceasedId) {
        return true;
      }
    }

    return false;
  }



  public clickDeceasedProfile(deceasedProfileOrderImage: DeceasedProfileOrderImage) {

    let found = false;

    for (let i = 0; i < this.selectedDeceasedProfile.length; i++) {

      if (this.selectedDeceasedProfile[i].deceasedProfile.deceasedId === deceasedProfileOrderImage.deceasedProfile.deceasedId) {
        this.selectedDeceasedProfile.splice(i, 1);
        found = true;
        break;
      }
    }

    if (!found) {
      this.selectedDeceasedProfile.push(deceasedProfileOrderImage);
    }

    this.deceasedProfileOrderImages.forEach(profile => {
      profile.order = '';
    });

    for (let i = 0; i < this.selectedDeceasedProfile.length; i++) {

      let found = false;

      for (let j = 0; j < this.deceasedProfileOrderImages.length; j++) {

        if (this.selectedDeceasedProfile[i].deceasedProfile.deceasedId === this.deceasedProfileOrderImages[j].deceasedProfile.deceasedId) {

          this.deceasedProfileOrderImages[j].order = (i + 1).toString();
          found = true;
          break;
        }

      }
    }


  }

  timeSlotSelected: Date;

  public timeSlotClicked(timeSelected: Date) {

    this.timeSlotSelected = new Date(timeSelected);

    console.log("timeSlotClicked : " + this.timeSlotSelected.toLocaleString());

  }

}

export interface BookingCalendarDateStatus {
  availableDate: Date[];
  almostFullDate: Date[];
  peakDate: Date[];
}

export interface DeceasedProfileOrderImage {

  order: string;
  deceasedProfile: DeceasedProfile;
  image: string;

}
